<template>
  <div id="dataManage">
    <el-row class="full_height">
      <el-col :span="4" class="positon_relative">
        <el-menu class="nav_menu" text-color="#A7CCF6"  :default-active=active active-text-color="#fff">
          <router-link :to="{name:'dataChart'}" class="link">

            <el-menu-item index="1">
              <template slot="title">
                  <i  class="el-icon-picture-outline"></i>
                  <span class="titleName">历史数据曲线</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link :to="{name:'warnRecord'}" class="link">
            <el-menu-item index="2">
              <template slot="title">
                <i class="el-icon-tickets"></i>&nbsp;
                <span>预报警记录</span>
              </template>
            </el-menu-item>
          </router-link>
          <!-- 重构:后端没有此巡查记录模块的接口,故先注释此模块 -->
          <router-link :to="{name:'inspectionRecords'}" class="link">
            <el-menu-item index="3">
              <template slot="title">
                <i class="el-icon-tickets"></i>&nbsp;巡查记录
              </template>
            </el-menu-item>
          </router-link>
          <!--查询设置，上方应该还有视频暂时没动-->
          <router-link :to="{name:'checkSet'}" class="link">
            <el-menu-item index="4">
              <template slot="title">
                <i class="el-icon-setting"></i>&nbsp;查询设置
              </template>
            </el-menu-item>
          </router-link>
<!--          测点关联-->
<!--          <router-link :to="{name:'relationPoint'}" class="link">-->
<!--            <el-menu-item index="5">-->
<!--              <template slot="title">-->
<!--                <i class="el-icon-connection"></i>&nbsp;关联测点-->
<!--              </template>-->
<!--            </el-menu-item>-->
<!--          </router-link>-->
        </el-menu>
      </el-col>
      <el-col :span="20" class="full_height">
        <router-view class="full_height tab_content"></router-view>
      </el-col>
    </el-row>

  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
        active:'1'
    };
  },
  beforeMount: function () {
    if(this.$route.query.measureNo){
        this.active='2'
        this.$router.push({
            name: 'warnRecord',
            query:{
                id:this.$route.query.id,
                measureNo:this.$route.query.measureNo,
                startDate:this.$route.query.startDate,
                endDate:this.$route.query.endDate,
            }
        })
    }  else{
        this.$router.push({name: 'dataChart'})

    }
  }
}
</script>

<!--<style>-->
<!--  #dataManage .el-submenu__title i {-->
<!--    color: #e68f02;-->
<!--  }-->
<!--</style>-->
<style scoped>
    @import "../../assets/css/style.css";

    #dataManage .tab_content{
        background: unset;
        /*overflow-y: auto;*/
    }
    #dataManage .el-submenu__title i {
      color: #e68f02;
    }
  /*  左侧导航栏*/
  /*  .titleContent{*/
  /*    width: 100%;*/
  /*    border: 1px solid red;*/
  /*    display: flex;*/
  /*    flex-direction: row;*/
  /*    justify-content: space-around;*/
  /*    align-items: center;*/
  /*  }*/

  /*.markIcon:hover{*/
  /*  color: #ffffff;*/
  /*}*/
  .titleName{
    width: 100%;
    overflow: hidden;/*超出部分隐藏*/
    text-overflow:ellipsis;/* 超出部分显示省略号 */
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataManage/index.vue